module.exports = __webpack_public_path__ + "img/L'Union_logo.8bfb5f97.svg";